import React from 'react';

const ArrowIcon = ({ width = 20, height = 20, fill = "#F04F4F" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.08411 16.6664C6.79911 16.6664 6.52161 16.5206 6.36661 16.2581C6.13161 15.8614 6.26328 15.3506 6.65828 15.1164C8.84578 13.8197 12.0833 11.2972 12.0833 9.99974C12.0833 8.69974 8.84661 6.17807 6.65828 4.88307C6.26328 4.64891 6.13161 4.13807 6.36661 3.74141C6.60078 3.34641 7.11161 3.21557 7.50828 3.44974C8.54995 4.06641 13.7499 7.28141 13.7499 9.99974C13.7499 12.7172 8.55078 15.9331 7.50828 16.5497C7.37495 16.6289 7.22828 16.6664 7.08411 16.6664Z"
      fill={fill}
    />
  </svg>
);

export default ArrowIcon;